import React, { Component } from "react";
import ReeValidate from 'ree-validate'
import {convertReadbleFormat} from './../helpers';
const $ = window.$;

class ForgotPassword extends Component {
  constructor(props) {
    super(props)
    this.validator = new ReeValidate({
      email: 'required|email',
    })
    this.state = {
      formData: {
        email: '',
      },
      formErrors: this.validator.errors
    }
  }

  handleSubmit = e => {
    e.preventDefault()
    const { removeError } = this.props
    removeError();
    const { formData } = this.state
    const { errors } = this.validator
    this.validator.validateAll(formData)
      .then(success => {
        if (success) {
          this.props.forgotPassword(formData.email).then(() => {
            this.setState({ formData: { email: '' } })
            $('#forgotPassword').modal('hide');
          }).catch(() => {
            return
          })
        } else {
          this.setState({ formErrors: errors })
        }
      })
  }

  handleChange = e => {
    const name = e.target.name
    const value = e.target.value
    const { errors } = this.validator
    errors.remove(name)
    this.setState({ formData: { ...this.state.formData, [name]: value } })
    this.validator.validate(name, value)
      .then(() => {
        this.setState({ formErrors: errors })
      })
  }

  closeModal = () => {
    this.validator.errors.clear();
    this.props.removeError();
    this.setState(
      { formData: { email: '' }, formErrors: this.validator.errors },
      () => $('#forgotPassword').modal('hide')
    );
  }

  render() {

    const { formData, formErrors } = this.state
    const { errors } = this.props

    return (
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <button type="button" className="close" onClick={this.closeModal}>&times;</button>
            <h3>Forgot Password?</h3>
          </div>
          <div style={{ 'padding': '50px' }} className="modal-body">
            {errors && errors.message && <div className="alert alert-danger">{errors.message}</div>}
            <form onSubmit={this.handleSubmit} noValidate>
              <div className="form-group">
                <label htmlFor="email">Email:</label>
                <input type="email"
                  className="form-control"
                  id="email"
                  placeholder="Enter email"
                  name="email"
                  onChange={this.handleChange}
                  required
                  value={formData.email} />
                {formErrors.has('email') &&
                  <span className="error text-danger">{convertReadbleFormat(formErrors.first('email'))}</span>
                }
              </div>

              <div className="row">
                <div className="col-md-6">
                </div>
                <div className="col-md-6 text-right">
                  <p><a  data-toggle="modal" data-target="#login" onClick={this.closeModal}>Back to Login</a></p>
                </div>
              </div>
              <button style={{ 'width': '100%' }} type="submit" className="btn circle btn-light border btn-md">Submit</button>
            </form>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-default" onClick={this.closeModal}>Close</button>
          </div>
        </div>
      </div>

    )
  }
}

export default ForgotPassword



// WEBPACK FOOTER //
// ./src/modals/forgotPassword.js